import React, { Fragment, Key, useEffect, useState } from 'react'
import './TGPlusSubscriptionDetails.scss'
import { Link, useParams } from 'react-router-dom'
import { Logger } from 'Helpers/Logger'
import tradegridPlusService from 'Services/tradegridPlusService'
import { tgplusModel } from 'Models'
import { TimeConverter } from 'Helpers/TimeConverter'
import { BreadCrumb, ModalWrapper } from 'Components'
import { useForm } from 'react-hook-form'
import Swal from 'sweetalert2'
import { CurrencyFormatter } from '../../../../../Helpers/CurrencyFormatter'
import { useDeliveryCountdown } from 'Hooks'
import { handleError } from 'Helpers'

interface formProps {
  plan: string
  nextSubscriptionPaymentDueDate?: Date
  installationCompletedAt?: Date
  solarProviderAccountId: string
  bypassFirstPayment: number | boolean
  enableMultiStationBonus: number | boolean
  decommissionedStationId: string
}

const TGPlusSubscriptionDetails = () => {
  const { subscriptionId } = useParams<{ subscriptionId: string }>()
  const [transaction, setTransaction] = useState<tgplusModel>()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(false)

  const [showModal, setShowModal] = useState(false)

  const toggleModal = () => {
    setShowModal((prevState) => !prevState)
  }

  const [showDueModal, setShowDueModal] = useState(false)

  const toggleDueModal = () => {
    setShowDueModal((prevState) => !prevState)
  }

  const [approveRequest, setApproveRequest] = useState(false)
  const [approveSubRequest, setApproveSubRequest] = useState(false)

  const [rejectionRequest, setRejectionRequest] = useState(false)

  // NEW: on hold request state
  const [onHoldRequest, setOnHoldRequest] = useState(false)

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<formProps>()

  const getSubscription = async () => {
    setLoading(true)
    await tradegridPlusService.singleSub(subscriptionId).then(
      (response) => {
        setLoading(false)
        setTransaction(response?.data.data)
        console.log('response transactionService', response)
      },
      (error: { response: object }) => {
        setLoading(false)
        Logger('response error', error.response)
      },
    )
  }

  useEffect(() => {
    getSubscription()
  }, [subscriptionId])

  function formatString(input: string) {
    const lowerCaseString = input.toLowerCase()

    // Remove underscores
    const formattedString = lowerCaseString.replace(/_/g, ' ')

    // capitalize status
    const capitalizedString = formattedString
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
    return capitalizedString
  }

  const transformFileUploadCategory = (fileUploadCategory: string): string => {
    if (fileUploadCategory === 'TRADEGRID_PLUS_APPLICATION_CAC_7') {
      return 'Application CAC 7'
    } else if (fileUploadCategory === 'PLP_APPLICATION_CAC_CERTIFICATE') {
      return 'CTC of CAC Registration form'
    }
    return 'Unknown file upload category'
  }

  const submit = handleSubmit(async (data: formProps) => {
    // console.log('data bypassFirstPayment', data.bypassFirstPayment)
    setApproveRequest(true)

    const filteredPayload: any = {
      plan: data.plan,
      solarProviderAccountId: data.solarProviderAccountId,
      bypassFirstPayment: Number(data.bypassFirstPayment) === 1 ? true : false,
      enableMultiStationBonus: Number(data.enableMultiStationBonus) === 1 ? true : false,
    }

    if (data.nextSubscriptionPaymentDueDate) {
      filteredPayload.nextSubscriptionPaymentDueDate = data.nextSubscriptionPaymentDueDate
    }

    if (data.installationCompletedAt) {
      filteredPayload.installationCompletedAt = data.installationCompletedAt
    }
    if (data.decommissionedStationId) {
      filteredPayload.decommissionedStationId = data.decommissionedStationId
    }

    await tradegridPlusService
      .subscriptionInstallationCompleted(filteredPayload, subscriptionId)
      .then(
        () => {
          setApproveRequest(false)
          Swal.fire({
            position: 'center',
            icon: 'success',
            text: 'Installation Completed',
            showConfirmButton: false,
            timer: 2000,
          })
          getSubscription()
        },
        (error) => {
          setApproveRequest(false)
          console.log('update Subscription error', error)

          Swal.fire({
            position: 'center',
            icon: 'warning',
            text: error.response.data.error,
            showConfirmButton: false,
            timer: 6500,
          })
        },
      )
  })

  const reject = async () => {
    setRejectionRequest(true)
    await tradegridPlusService.approveSubscription('REJECTED', subscriptionId).then(
      () => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          text: 'Rejection Completed',
          showConfirmButton: false,
          timer: 2000,
        })

        setRejectionRequest(false)

        setTimeout(() => {
          getSubscription()
          toggleModal()
        }, 1000)
      },
      (error) => {
        setRejectionRequest(false)
        console.log('update Subscription error', error)

        Swal.fire({
          position: 'center',
          icon: 'warning',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 6500,
        })
      },
    )
  }

  const ExpiryDate = (approvedDate: string) => {
    const countDown = useDeliveryCountdown(approvedDate)
    return countDown
  }

  const approveInstallation = async () => {
    setApproveSubRequest(true)
    await tradegridPlusService.approveSubscription('APPROVED', subscriptionId).then(
      async () => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          text: 'Approval Completed',
          showConfirmButton: false,
          timer: 2000,
        })
        setApproveSubRequest(false)

        setTimeout(() => {
          getSubscription()
        }, 1000)
      },
      (error) => {
        setApproveSubRequest(false)
        console.log('approveSubscription error', error)

        Swal.fire({
          position: 'center',
          icon: 'warning',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 6500,
        })
      },
    )
  }

  const putOnHold = async (status: string) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `Are you sure you want to ${status === 'ON_HOLD' ? 'put this station on hold' : 'reactivate this station'}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#186AFF',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, continue!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setOnHoldRequest(true)
        await tradegridPlusService.approveSubscription(status, subscriptionId).then(
          () => {
            Swal.fire({
              position: 'center',
              icon: 'success',
              text: `Subscription ${status === 'ON_HOLD' ? 'put on hold' : 'reactivated'} successfully`,
              showConfirmButton: false,
              timer: 2000,
            })
            setOnHoldRequest(false)
            setTimeout(() => {
              getSubscription()
            }, 1000)
          },
          (error) => {
            setOnHoldRequest(false)
            console.log('putOnHold error', error)
            Swal.fire({
              position: 'center',
              icon: 'warning',
              text: error.response?.data?.error ?? 'An error occurred',
              showConfirmButton: false,
              timer: 1500,
            })
          },
        )
      }
    })
  }

  const [showAdditionalFields, setShowAdditionalFields] = useState(false)

  const [solarSubscriptions, setSolarSubscriptions] = useState<
    Array<{
      id: string
      businessName: string
      createdAt: string
    }>
  >()

  const [solarLoading, setSolarLoading] = useState(false)

  const [pageSolarNumber, setPageSolarNumber] = useState(1)

  const [sortOrder, setSortOrder] = useState('DESC')

  const [sortSolar, setSortSolar] = useState('DESC')

  const [solarPaginationData, setSolarPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  const getSolarProviders = async () => {
    setSolarLoading(true)

    await tradegridPlusService.solarProviders(pageSolarNumber, sortOrder, status).then(
      (response) => {
        setSolarLoading(false)
        console.log('solarProviders', response?.data.data)
        setSolarSubscriptions(response?.data.data)

        setSolarPaginationData({
          pageNumber: response?.data.data.pageNumber,
          pageSize: response?.data.data.pageSize,
          total: response?.data.data.total,
        })
      },
      (error: { response: object }) => {
        setSolarLoading(false)
        Logger('response error', error.response)
      },
    )
  }

  useEffect(() => {
    getSolarProviders()
  }, [sortSolar, pageSolarNumber])

  const makePayment = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You are about to trigger debit on the subscriber wallet, Are you sure you want to continue?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#186AFF',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, continue!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true)
        Swal.fire({
          title: 'Loading...',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading()
          },
        })
        await tradegridPlusService.makePayment(subscriptionId).then(
          () => {
            Swal.close()
            setLoading(false)
            Swal.fire('Done!', 'Payment initiated succesfully', 'success')
          },
          (error: { response: { data: { error: string } } }) => {
            console.log('error', error.response)
            setLoading(false)
            Swal.close()
            Swal.fire({
              position: 'center',
              icon: 'warning',
              text: error.response.data.error,
              showConfirmButton: false,
              timer: 5000,
            })
          },
        )
      }
    })
  }

  const decommision = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Are you sure you want to decommission this station? Note This action is irreversible.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#186AFF',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, continue!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true)
        Swal.fire({
          text: 'Decommissioning, please wait a moment...',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading()
          },
        })
        await tradegridPlusService.decommission(subscriptionId).then(
          () => {
            Swal.close()
            setLoading(false)
            Swal.fire('Done!', 'Decommissioned succesfully', 'success')
          },
          (error: { response: { data: { error: string } } }) => {
            console.log('error', error.response)
            setLoading(false)
            Swal.close()
            Swal.fire({
              position: 'center',
              icon: 'warning',
              text: error.response.data.error,
              showConfirmButton: false,
              timer: 5000,
            })
          },
        )
      }
    })
  }

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
  } = useForm<{ nextSubscriptionPaymentDueDate: string }>()

  const [updateDueRequest, setUpdateDueRequest] = useState(false)

  const updateDueDate = async (data: { nextSubscriptionPaymentDueDate: string }) => {
    setUpdateDueRequest(true)
    await tradegridPlusService.updateDueDate(subscriptionId, data).then(
      () => {
        setUpdateDueRequest(false)
        Swal.fire({
          position: 'center',
          icon: 'success',
          text: 'New due date saved!',
          showConfirmButton: false,
          timer: 2000,
        })

        toggleDueModal()
      },
      (error) => {
        setUpdateDueRequest(false)
        Swal.fire({
          position: 'center',
          icon: 'warning',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 1500,
        })
      },
    )
  }

  const [tgpludStations, setTGplusStations] = useState<tgplusModel[]>([])
  const [stationPage, setStationPage] = useState(1)
  const [stationPages, setStationPages] = useState<number[]>([1])

  const [stationPaginationData, setStationPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  const getFillingStations = async () => {
    setLoading(true)

    await tradegridPlusService.index(stationPage, 'DESC', 'DECOMMISSIONED').then(
      (response) => {
        setLoading(false)
        const pageNumber = response?.data?.data?.pageNumber ?? 1
        const pageSize = response?.data?.data?.pageSize ?? 20
        const total = response?.data?.data?.total ?? 1

        setTGplusStations(response?.data?.data?.dataset ?? [])

        setStationPage(pageNumber)

        setStationPaginationData({ pageNumber, pageSize, total })

        const totalPages = Math.max(1, Math.ceil(total / (pageSize || 1)))

        setStationPages(Array.from({ length: totalPages }, (_, index) => index + 1))
      },
      (error) => {
        handleError(error)
        setLoading(false)
      },
    )
  }

  useEffect(() => {
    getFillingStations()
  }, [stationPage])

  return (
    <div className='TGPlusSubscriptionDetails'>
      <div className='container'>
        <div className='container mb-5'>
          <BreadCrumb
            title={'Subscription Details'}
            parent={'Tradegrid Plus'}
            parentUrl={'tgplus-subscription'}
            showTitle={false}
          ></BreadCrumb>
          <div className='row'>
            <div className='col-md-5'>
              <h6 className='mt-3'>Subscription Details</h6>
            </div>
            <div className='col-md-7 text-md-end'>
              <button className='btn btn-custom me-2 mb-1' onClick={decommision}>
                Decommission
              </button>
              <button className='btn btn-custom me-2 mb-1' onClick={makePayment}>
                Make Payment
              </button>
              <Link
                to={`/tgplus-subscription/${subscriptionId}/transaction`}
                className='btn btn-custom me-2 mb-1 text-decoration-none decoration-none '
              >
                Transactions history
              </Link>
              <button className='btn btn-custom mb-1' onClick={toggleDueModal}>
                Update Due Date
              </button>
              {transaction?.status != 'ON_HOLD' && (
                <button
                  className='btn btn-custom ms-3 mb-1'
                  onClick={() => putOnHold('ON_HOLD')}
                  disabled={onHoldRequest}
                >
                  {onHoldRequest && <span className='spinner-border spinner-border-sm'></span>} On
                  Hold
                </button>
              )}
              {transaction?.status === 'ON_HOLD' && (
                <button
                  className='btn btn-custom ms-3 mb-1'
                  onClick={() => putOnHold('INSTALLATION_COMPLETED')}
                  disabled={onHoldRequest}
                >
                  {onHoldRequest && <span className='spinner-border spinner-border-sm'></span>}
                  Remove Hold
                </button>
              )}
            </div>
          </div>

          <div className='row'>
            <div className='col-md-6'>
              <div className='card mt-3 mb-5 border-0'>
                <div className='card-header bg-white'>
                  <b>Subscription Date: </b>
                  {TimeConverter(transaction?.createdAt)}
                </div>
                <div className='card-body'>
                  <div className='profile-item row'>
                    <div className='name col-6'>User</div>
                    <div className='value col-6'>
                      {transaction?.customer?.firstName} {transaction?.customer?.lastName}
                    </div>
                  </div>
                  <div className='profile-item row'>
                    <div className='name col-6'>Retail Station Name:</div>
                    <div className='value col-6'>{transaction?.stationName}</div>
                  </div>
                  <div className='profile-item row'>
                    <div className='name col-6'>Products:</div>
                    <div className='value col-6'>
                      {transaction?.solarPowerCapacity} Kva Solar Capacity
                    </div>
                  </div>
                  <div className='profile-item row'>
                    <div className='name col-6'>No of Pumps:</div>
                    <div className='value col-6'>{transaction?.noOfPumps}</div>
                  </div>
                  <div className='profile-item row'>
                    <div className='name col-6'>Daily Sales Volume:</div>
                    <div className='value col-6'>{transaction?.dailySalesVolume}</div>
                  </div>

                  <div className='profile-item row'>
                    <div className='name col-6'>Station Address:</div>
                    <div className='value col-6'>{transaction?.stationAddress}</div>
                  </div>

                  <div className='profile-item row'>
                    <div className='name col-6'>State:</div>
                    <div className='value col-6'>{transaction?.stationState}</div>
                  </div>

                  <div className='profile-item row'>
                    <div className='name col-6'>Plan Name:</div>
                    <div className='value col-6'>{transaction?.plan}</div>
                  </div>

                  <div className='profile-item row'>
                    <div className='name col-6'>Plan Battery:</div>
                    <div className='value col-6'>
                      {transaction?.subscriptionPlanFullInfo?.battery}
                    </div>
                  </div>
                  <div className='profile-item row'>
                    <div className='name col-6'>Plan Display Name:</div>
                    <div className='value col-6'>
                      {transaction?.subscriptionPlanFullInfo?.displayName}
                    </div>
                  </div>
                  <div className='profile-item row'>
                    <div className='name col-6'>Plan Inverter:</div>
                    <div className='value col-6'>
                      {transaction?.subscriptionPlanFullInfo?.inverter}
                    </div>
                  </div>
                  <div className='profile-item row'>
                    <div className='name col-6'>Plan Monthly Subscription:</div>
                    <div className='value col-6'>
                      {CurrencyFormatter(
                        transaction?.subscriptionPlanFullInfo?.monthlySubscriptionMajor ?? 0,
                      )}
                    </div>
                  </div>

                  <div className='profile-item row'>
                    <div className='name col-6'>Subscription Duration:</div>
                    <div className='value col-6'>
                      {transaction?.subscriptionDurationYears} Years
                    </div>
                  </div>
                  <div className='profile-item row'>
                    <div className='name col-6'>Pump:</div>
                    <div className='value col-6'>
                      {transaction?.subscriptionPlanFullInfo?.pumps}
                    </div>
                  </div>
                  <div className='profile-item row'>
                    <div className='name col-6'>Bypass FirstPayment:</div>
                    <div className='value col-6'>
                      {transaction?.firstPaymentBypassed
                        ? 'First payment bypassed'
                        : 'First payment not bypassed'}
                    </div>
                  </div>
                  <div className='profile-item row'>
                    <div className='name col-6'>Enable Multi Station Bonus:</div>
                    <div className='value col-6'>
                      {transaction?.enableMultiStationBonus ? 'Enabled' : 'Disabled'}
                    </div>
                  </div>

                  <div className='profile-item row'>
                    <div className='name col-6'>Decommissioned station:</div>
                    <div className='value col-6'>{transaction?.decommissionedStationId}</div>
                  </div>
                </div>

                <div className='container ducumentation mb-4'>
                  {transaction?.verificationDocuments &&
                    transaction?.verificationDocuments.length > 0 && (
                      <div className='col-md-12'>
                        <div className='my-3 title'>Documentation</div>
                        <div className='row'>
                          {transaction?.verificationDocuments.map((res, index) => {
                            return (
                              <div className='col-6 col-md-6 col-xl-3' key={index}>
                                <div
                                  className='uploadedDocument'
                                  style={{
                                    backgroundImage: `linear-gradient(to bottom, rgba(000, 000, 000, 0.20), rgba(000, 000, 000, 0.20)), url(${res.url})`,
                                  }}
                                >
                                  <div className='icons'>
                                    <a href={res.url} target='_blank' rel='noreferrer'>
                                      <button className='btn'>
                                        <svg
                                          width='18'
                                          height='18'
                                          viewBox='0 0 24 24'
                                          fill='none'
                                          xmlns='http://www.w3.org/2000/svg'
                                        >
                                          <path
                                            d='M11.9999 16.3319C9.60992 16.3319 7.66992 14.3919 7.66992 12.0019C7.66992 9.61187 9.60992 7.67188 11.9999 7.67188C14.3899 7.67188 16.3299 9.61187 16.3299 12.0019C16.3299 14.3919 14.3899 16.3319 11.9999 16.3319ZM11.9999 9.17188C10.4399 9.17188 9.16992 10.4419 9.16992 12.0019C9.16992 13.5619 10.4399 14.8319 11.9999 14.8319C13.5599 14.8319 14.8299 13.5619 14.8299 12.0019C14.8299 10.4419 13.5599 9.17188 11.9999 9.17188Z'
                                            fill='#292D32'
                                          />
                                          <path
                                            d='M12.0001 21.0205C8.24008 21.0205 4.69008 18.8205 2.25008 15.0005C1.19008 13.3505 1.19008 10.6605 2.25008 9.00047C4.70008 5.18047 8.25008 2.98047 12.0001 2.98047C15.7501 2.98047 19.3001 5.18047 21.7401 9.00047C22.8001 10.6505 22.8001 13.3405 21.7401 15.0005C19.3001 18.8205 15.7501 21.0205 12.0001 21.0205ZM12.0001 4.48047C8.77008 4.48047 5.68008 6.42047 3.52008 9.81047C2.77008 10.9805 2.77008 13.0205 3.52008 14.1905C5.68008 17.5805 8.77008 19.5205 12.0001 19.5205C15.2301 19.5205 18.3201 17.5805 20.4801 14.1905C21.2301 13.0205 21.2301 10.9805 20.4801 9.81047C18.3201 6.42047 15.2301 4.48047 12.0001 4.48047Z'
                                            fill='#292D32'
                                          />
                                        </svg>
                                      </button>
                                    </a>
                                    <a href={res.url} target='_blank' rel='noreferrer' download>
                                      <button className='btn'>
                                        <svg
                                          width='18'
                                          height='18'
                                          viewBox='0 0 24 24'
                                          fill='none'
                                          xmlns='http://www.w3.org/2000/svg'
                                        >
                                          <path
                                            d='M9 17.75C8.9 17.75 8.81 17.73 8.71 17.69C8.43 17.58 8.25 17.3 8.25 17V11C8.25 10.59 8.59 10.25 9 10.25C9.41 10.25 9.75 10.59 9.75 11V15.19L10.47 14.47C10.76 14.18 11.24 14.18 11.53 14.47C11.82 14.76 11.82 15.24 11.53 15.53L9.53 17.53C9.39 17.67 9.19 17.75 9 17.75Z'
                                            fill='#292D32'
                                          />
                                          <path
                                            d='M9.00043 17.7514C8.81043 17.7514 8.62043 17.6814 8.47043 17.5314L6.47043 15.5314C6.18043 15.2414 6.18043 14.7614 6.47043 14.4714C6.76043 14.1814 7.24043 14.1814 7.53043 14.4714L9.53043 16.4714C9.82043 16.7614 9.82043 17.2414 9.53043 17.5314C9.38043 17.6814 9.19043 17.7514 9.00043 17.7514Z'
                                            fill='#292D32'
                                          />
                                          <path
                                            d='M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H14C14.41 1.25 14.75 1.59 14.75 2C14.75 2.41 14.41 2.75 14 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V10C21.25 9.59 21.59 9.25 22 9.25C22.41 9.25 22.75 9.59 22.75 10V15C22.75 20.43 20.43 22.75 15 22.75Z'
                                            fill='#292D32'
                                          />
                                          <path
                                            d='M22 10.7485H18C14.58 10.7485 13.25 9.41852 13.25 5.99852V1.99852C13.25 1.69852 13.43 1.41852 13.71 1.30852C13.99 1.18852 14.31 1.25852 14.53 1.46852L22.53 9.46852C22.74 9.67852 22.81 10.0085 22.69 10.2885C22.57 10.5685 22.3 10.7485 22 10.7485ZM14.75 3.80852V5.99852C14.75 8.57852 15.42 9.24852 18 9.24852H20.19L14.75 3.80852Z'
                                            fill='#292D32'
                                          />
                                        </svg>
                                      </button>
                                    </a>
                                  </div>
                                </div>
                                <div className='doc-name'>
                                  {transformFileUploadCategory(res.fileCategory)}
                                </div>
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    )}
                </div>
              </div>
            </div>

            <div className='col-md-6'>
              <div className='card mt-3 mb-3 border-0'>
                <div className='card-header bg-white'>
                  <div className='row'>
                    <div className='col-sm-12 col-lg-4 col-xl-6 fs-6 text-dark'>
                      Document & Agreement
                    </div>
                    <div className='col-sm-12 col-lg-8 col-xl-6 text-lg-end  mt-2 mt-xl-0'>
                      {transaction && (
                        <span
                          className={
                            ['APPROVED', 'INSTALLATION_COMPLETED', 'ACTIVE'].includes(
                              transaction.status,
                            )
                              ? 'status-success text-dark ms-lg-2'
                              : 'status-danger'
                          }
                        >
                          {formatString(transaction?.status)}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className='card-body'>
                  {transaction && transaction.status === 'APPROVED' && (
                    <form onSubmit={submit}>
                      <div className='completed-installation-form-info'>
                        <div className='title'>Installation in progress</div>
                        <div className='details'>
                          Complete when engineers installs solar system successfully
                        </div>
                      </div>

                      <div className='form-group mt-3'>
                        <label htmlFor='plan'>Solar Plan</label>
                        <select
                          id='plan'
                          className='form-control'
                          {...register('plan', {
                            required: 'Please select solar plan',
                          })}
                        >
                          <option value=''>select plan</option>
                          <option value='LITE' selected={transaction?.plan === 'LITE'}>
                            LITE
                          </option>
                          <option value='PRO' selected={transaction?.plan === 'PRO'}>
                            PRO
                          </option>
                          <option value='MAX' selected={transaction?.plan === 'MAX'}>
                            MAX
                          </option>
                        </select>
                        {errors.plan && <span className='errors'>{errors.plan.message}</span>}
                      </div>

                      <div className='form-group mt-3'>
                        <label htmlFor='solarProviderAccountId'>Solar Provider</label>
                        <select
                          id='solarProviderAccountId'
                          className='form-control'
                          {...register('solarProviderAccountId', {
                            required: 'Please select solar provider',
                          })}
                        >
                          <option value=''>select provider</option>
                          {solarSubscriptions &&
                            solarSubscriptions.map(
                              (
                                res: { id: string; businessName: string; createdAt: string },
                                index: Key,
                              ) => {
                                return (
                                  <option value={res.id} key={index}>
                                    {res.businessName}
                                  </option>
                                )
                              },
                            )}
                        </select>
                        {errors.solarProviderAccountId && (
                          <span className='errors'>{errors.solarProviderAccountId.message}</span>
                        )}
                      </div>

                      {showAdditionalFields === true && (
                        <Fragment>
                          <div className='form-group mt-3'>
                            <label htmlFor='nextSubscriptionPaymentDueDate'>
                              Next subscription payment due date
                            </label>
                            <input
                              type='date'
                              id='nextSubscriptionPaymentDueDate'
                              className='form-control'
                              {...register('nextSubscriptionPaymentDueDate')}
                            />
                            {errors.nextSubscriptionPaymentDueDate && (
                              <span className='errors'>
                                {errors.nextSubscriptionPaymentDueDate.message}
                              </span>
                            )}
                          </div>

                          <div className='form-group mt-3'>
                            <label htmlFor='installationCompletedAt'>
                              Installation completed date
                            </label>
                            <input
                              type='date'
                              id='installationCompletedAt'
                              className='form-control'
                              {...register('installationCompletedAt')}
                            />
                            {errors.installationCompletedAt && (
                              <span className='errors'>
                                {errors.installationCompletedAt.message}
                              </span>
                            )}
                          </div>

                          <div className='form-group mt-3'>
                            <label htmlFor='bypassFirstPayment'>Bypass first payment?</label>

                            <div className='flex space-x-6 mt-2'>
                              <label className='flex items-center cursor-pointer'>
                                <input
                                  type='radio'
                                  value={1}
                                  id='bypassFirstPaymentYes'
                                  className='form-check-input sr-only peer'
                                  {...register('bypassFirstPayment', {
                                    required: 'Please select bypass first payment option',
                                    setValueAs: (value) => value === 'true',
                                  })}
                                />
                                <span className='text-gray-700'>Yes</span>
                              </label>
                              <label className='flex items-center cursor-pointer ms-4'>
                                <input
                                  type='radio'
                                  value={0}
                                  id='bypassFirstPaymentNo'
                                  className='form-check-input sr-only peer'
                                  defaultChecked
                                  {...register('bypassFirstPayment', {
                                    required: 'Please select bypass first payment option',
                                    setValueAs: (value) => value === 'true',
                                  })}
                                />
                                <span className='text-gray-700'>No</span>
                              </label>
                            </div>
                            {errors.bypassFirstPayment && (
                              <span className='errors'>{errors.bypassFirstPayment.message}</span>
                            )}
                          </div>




                          <div className='form-group mt-3'>
                            <label htmlFor='enableMultiStationBonus'>Enable Multi Station Bonus?</label>

                            <div className='flex space-x-6 mt-2'>
                              <label className='flex items-center cursor-pointer'>
                                <input
                                  type='radio'
                                  value={1}
                                  id='enableMultiStationBonus'
                                  className='form-check-input sr-only peer'
                                  {...register('enableMultiStationBonus', {
                                    required: 'Please select option to enable or disble multi station bonus',
                                    setValueAs: (value) => value === 'true',
                                  })}
                                />
                                <span className='text-gray-700'>Yes</span>
                              </label>
                              <label className='flex items-center cursor-pointer ms-4'>
                                <input
                                  type='radio'
                                  value={0}
                                  id='enableMultiStationBonus'
                                  className='form-check-input sr-only peer'
                                  defaultChecked
                                  {...register('enableMultiStationBonus', {
                                    required: 'Please select option to enable or disble multi station bonus',
                                    setValueAs: (value) => value === 'true',
                                  })}
                                />
                                <span className='text-gray-700'>No</span>
                              </label>
                            </div>
                            {errors.enableMultiStationBonus && (
                              <span className='errors'>{errors.enableMultiStationBonus.message}</span>
                            )}
                          </div>
                        </Fragment>
                      )}

                      {Number(watch('bypassFirstPayment')) === 1 && (
                        <div className='form-group mt-3'>
                          <label htmlFor='decommissionedStationId'>Decommissioned Station</label>
                          <select
                            id='decommissionedStationId'
                            className='form-control'
                            {...register('decommissionedStationId', {
                              required: 'Please select decommissioned station',
                            })}
                          >
                            <option value=''>select</option>
                            {tgpludStations &&
                              tgpludStations.map((res: tgplusModel, index: Key) => {
                                return (
                                  <option value={res.id} key={index}>
                                    {res.stationName} - {res.stationState}
                                  </option>
                                )
                              })}
                          </select>
                          {errors.decommissionedStationId && (
                            <span className='errors'>{errors.decommissionedStationId.message}</span>
                          )}
                        </div>
                      )}

                      <div className='d-flex align-items-center show-more'>
                        <div className='flex-grow-1 border-bottom'></div>
                        <span
                          className='mx-3'
                          onClick={() => setShowAdditionalFields(!showAdditionalFields)}
                        >
                          Show {showAdditionalFields === false ? 'more' : 'less'}
                          <svg
                            width='12'
                            height='12'
                            viewBox='0 0 19 18'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                            className='ms-2'
                          >
                            <circle
                              cx='9'
                              cy='9'
                              r='8.28'
                              transform='matrix(-4.37114e-08 1 1 4.37114e-08 0.5 0)'
                              stroke='#FC6FBB'
                              strokeWidth='1.44'
                            />
                            {showAdditionalFields === false ? (
                              <path
                                d='M12.8417 7.69727L10.0911 10.4479C9.76621 10.7727 9.23465 10.7727 8.9098 10.4479L6.15918 7.69727'
                                stroke='#FC6FBB'
                                strokeWidth='1.5'
                                strokeMiterlimit='10'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              />
                            ) : (
                              <path
                                d='M12.8417 10.3027L10.0911 7.55211C9.76621 7.22727 9.23465 7.22727 8.9098 7.55211L6.15918 10.3027'
                                stroke='#FC6FBB'
                                strokeWidth='1.5'
                                strokeMiterlimit='10'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              />
                            )}
                          </svg>
                        </span>
                        <div className='flex-grow-1 border-bottom'></div>
                      </div>

                      <div className='form-group mt-3'>
                        <button type='submit' className='btn approve-btn' disabled={approveRequest}>
                          {' '}
                          {approveRequest && (
                            <span className='spinner-border spinner-border-sm'></span>
                          )}{' '}
                          Installation Completed
                        </button>
                      </div>
                    </form>
                  )}

                  {transaction && transaction.solarPowerCapacity && (
                    <div className='row h-100 capacity-details'>
                      <div className='col-md-6 text-start'>
                        <div className='capacity'>{transaction.solarPowerCapacity}kva</div>
                      </div>
                      <div className='col-md-6 my-auto text-end'>
                        <div className='amount'>
                          @N{CurrencyFormatter(transaction.monthlySubscriptionMajor)}/m
                        </div>
                        <div className='due-date'>
                          Next Due Date {TimeConverter(transaction.nextSubscriptionPaymentDueDate)}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {transaction?.signWellContractCompletedUrl && (
                <div className='card shadow-sm border border-success'>
                  <div className='card-body'>
                    <div className='row h-100'>
                      <div
                        className='col-6 my-auto text-start text-success'
                        style={{ fontSize: '0.9rem' }}
                      >
                        Contract signed
                        <svg
                          width='20'
                          height='20'
                          viewBox='0 0 20 20'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                          style={{ marginLeft: '8px', verticalAlign: 'middle' }}
                        >
                          <circle cx='10' cy='10' r='10' fill='#28a745' />
                          <path
                            d='M6 10.5L9 13.5L14 8.5'
                            stroke='white'
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                        </svg>
                      </div>
                      <div className='col-md-6 text-end'>
                        <a
                          href={transaction?.signWellContractCompletedUrl ?? ''}
                          target='_blank'
                          rel='noreferrer'
                        >
                          <button className='btn btn-default view-contract-btn'>
                            View Signed Contract
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {transaction?.signWellContractSigningUrl &&
                transaction?.signWellContractCompletedUrl === null && (
                  <div className='card border border-danger'>
                    <div className='card-body'>
                      <div className='row h-100'>
                        <div
                          className='col-6 my-auto text-start text-danger'
                          style={{ fontSize: '0.9rem' }}
                        >
                          Contract Not signed by subscriber
                        </div>
                        <div className='col-6 my-auto text-end'>
                          <a
                            href={transaction?.signWellContractSigningUrl}
                            target='_blank'
                            rel='noreferrer'
                          >
                            <button className='btn btn-default view-contract-btn'>
                              View Contract
                            </button>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              {transaction &&
                ['PENDING_APPROVAL', 'PENDING_SIGNATURE', 'CONTRACT_SIGNED'].includes(
                  transaction.status,
                ) === true && (
                  <div className='card border-0 mb-3 mt-3 approval-card shadow-sm'>
                    <div className='card-body'>
                      <div className='row h-100'>
                        <div className='col-md-6 my-auto'>
                          <div className='fs-4 title'>Approve Subscription</div>
                        </div>
                        <div className='col-md-6 my-auto value text-end'>
                          <button
                            className='btn btn-default'
                            onClick={approveInstallation}
                            disabled={approveSubRequest}
                          >
                            {' '}
                            {approveSubRequest && (
                              <span className='spinner-border spinner-border-sm'></span>
                            )}{' '}
                            Approve
                          </button>

                          <button
                            type='button'
                            className='btn reject-btn ms-3'
                            onClick={toggleModal}
                          >
                            Reject
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              {transaction && transaction.solarPowerCapacity && (
                <div className='card border-0 mb-3 delivery-details'>
                  <div className='card-body'>
                    <div className='row h-100'>
                      <div className='col-md-9'>
                        <div className='fs-4 title'>Free Delivery</div>
                      </div>
                      <div className='col-md-3 my-auto value'>
                        <svg
                          width='15'
                          height='15'
                          viewBox='0 0 24 24'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
                            fill='#516F93'
                          />
                          <path
                            d='M15.7096 15.9298C15.5796 15.9298 15.4496 15.8998 15.3296 15.8198L12.2296 13.9698C11.4596 13.5098 10.8896 12.4998 10.8896 11.6098V7.50977C10.8896 7.09977 11.2296 6.75977 11.6396 6.75977C12.0496 6.75977 12.3896 7.09977 12.3896 7.50977V11.6098C12.3896 11.9698 12.6896 12.4998 12.9996 12.6798L16.0996 14.5298C16.4596 14.7398 16.5696 15.1998 16.3596 15.5598C16.2096 15.7998 15.9596 15.9298 15.7096 15.9298Z'
                            fill='white'
                          />
                        </svg>
                        {transaction?.approvedAt ? ExpiryDate(transaction?.approvedAt) : 0} Days
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {transaction && transaction.solarPowerCapacity && (
                <div className='card border-0 installation-progress'>
                  <div className='card-body'>
                    <div className='row h-100'>
                      <div className='col-6 col-md-12 col-lg-4 col-xl-6 col-md-8--'>
                        <div className='title'>Installation in progress</div>
                        <div className='details'>
                          Complete when engineers installs solar <br />
                          system successfully
                        </div>
                      </div>
                      <div className='col-6  col-md-12 col-lg-8 col-xl-6 col-md-4-- my-auto text-end'>
                        {transaction && transaction.status === 'INSTALLATION_COMPLETED' && (
                          <Fragment>
                            {transaction && (
                              <span
                                className={
                                  ['APPROVED', 'INSTALLATION_COMPLETED', 'ACTIVE'].includes(
                                    transaction.status,
                                  )
                                    ? 'status-success text-dark ms-2'
                                    : 'status-danger'
                                }
                              >
                                Completed
                              </span>
                            )}
                          </Fragment>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <ModalWrapper showModal={showModal} closeModal={toggleModal} title='Reject Application'>
        <form className='rejection-form'>
          <div className='form-group'>
            <label htmlFor=''>Reason for Rejection</label>
            <textarea className='form-control' />
          </div>

          <div className='form-group mt-3'>
            <button
              type='button'
              className='btn btn-default btn-reject-001 w-100'
              onClick={reject}
              disabled={rejectionRequest}
            >
              {rejectionRequest && <span className='spinner-border spinner-border-sm'></span>}{' '}
              Submit
            </button>
          </div>
        </form>
      </ModalWrapper>

      <ModalWrapper
        showModal={showDueModal}
        closeModal={toggleDueModal}
        title='Update due date'
        hideHeader={false}
      >
        <form className='rejection-form' onSubmit={handleSubmit2(updateDueDate)}>
          <div className='form-group'>
            <label htmlFor=''>New Date</label>
            <input
              type='date'
              className='form-control'
              {...register2('nextSubscriptionPaymentDueDate')}
            />
            {errors2.nextSubscriptionPaymentDueDate && (
              <span className='errors'>{errors2.nextSubscriptionPaymentDueDate.message}</span>
            )}
          </div>

          <div className='form-group mt-3'>
            <button
              type='submit'
              className='btn btn-default btn-reject-001 w-100'
              disabled={updateDueRequest}
            >
              {updateDueRequest && <span className='spinner-border spinner-border-sm'></span>}{' '}
              Update
            </button>
          </div>
        </form>
      </ModalWrapper>
    </div>
  )
}

export default TGPlusSubscriptionDetails
